(function () {
  function formatMoney(value, format) {
    const amount = Number(value || 0);
    const price = (amount / 100).toFixed(2);
    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/g, price).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount / 100).toString());
    }
    return `$${price}`;
  }

  function createEl(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  }

  function initBundleSection(section) {
    if (section.dataset.bundleInitialized === 'true') {
      return;
    }

    const configNode = section.querySelector('[data-bundle-config]');
    if (!configNode) {
      return;
    }

    section.dataset.bundleInitialized = 'true';

    const data = JSON.parse(configNode.textContent);

    const products = Array.isArray(data.products) ? data.products.filter(Boolean) : [];
    if (!products.length) {
      return;
    }

    const state = {
      purchaseType: 'subscribe',
      quantities: {},
      currentIndex: 0,
      nutritionOpen: false,
      showingNutritionImage: false,
      adding: false,
      sellingPlanId: (products[0]?.sellingPlans || [])[0]?.id || null
    };

    let monsterCartObserver = null;
    let monsterCartPatchQueued = false;
    let monsterCartControlsBound = false;
    let monsterCartGroupingTimeouts = [];

    const els = {
      title: section.querySelectorAll('[data-bundle-product-title]'),
      subheading: section.querySelectorAll('[data-bundle-subheading]'),
      mainImage: section.querySelector('[data-main-image]'),
      thumbs: section.querySelector('[data-gallery-thumbnails]'),
      prevArrow: section.querySelector('[data-gallery-prev]'),
      nextArrow: section.querySelector('[data-gallery-next]'),
      flavorList: section.querySelector('[data-flavor-list]'),
      progress: section.querySelector('[data-bundle-progress]'),
      steps: Array.from(section.querySelectorAll('[data-bundle-steps] .bundle-option')),
      selectionStatus: section.querySelector('[data-selection-status]'),
      subOriginal: section.querySelector('[data-sub-original]'),
      subPrice: section.querySelector('[data-sub-price]'),
      subDiscountBadge: section.querySelector('[data-sub-discount-badge]'),
      subscribeFrequency: section.querySelector('[data-subscribe-frequency]'),
      onetimePrice: section.querySelector('[data-onetime-price]'),
      cartButton: section.querySelector('[data-cart-button]'),
      cartButtonText: section.querySelector('[data-cart-button-text]'),
      cartPricing: section.querySelector('[data-cart-pricing]'),
      btnOriginal: section.querySelector('[data-btn-original]'),
      btnFinal: section.querySelector('[data-btn-final]'),
      subscribeBox: section.querySelector('[data-purchase-box="subscribe"]'),
      onetimeBox: section.querySelector('[data-purchase-box="onetime"]'),
      radioSubscribe: section.querySelector('[data-radio-subscribe]'),
      radioOnetime: section.querySelector('[data-radio-onetime]'),
      nutritionToggles: section.querySelectorAll('[data-nutrition-toggle]'),
      nutritionDropdowns: section.querySelectorAll('[data-nutrition-dropdown]'),
      nutritionIcons: section.querySelectorAll('[data-nutrition-icon]'),
      nutritionLists: section.querySelectorAll('[data-nutrition-list]'),
      nutritionImages: section.querySelectorAll('[data-nutrition-image]'),
      selectedFlavors: section.querySelectorAll('[data-selected-flavor]'),
      tierCols: Array.from(section.querySelectorAll('[data-tier-col]')),
      tierSegments: Array.from(section.querySelectorAll('[data-tier-segment]')),
      giftItems: Array.from(section.querySelectorAll('[data-gift-item]'))
    };

    function getCartAddUrl() {
      const baseUrl = window.routes?.cart_add_url || '/cart/add';
      return baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;
    }

    function getCartUrl() {
      return window.routes?.cart_url || '/cart';
    }

    function getCartJsonUrl() {
      return `${getCartUrl()}.js`;
    }

    function getCartUpdateUrl() {
      return `${getCartUrl()}/update.js`;
    }

    function getCartChangeUrl() {
      return `${getCartUrl()}/change.js`;
    }

    const MONSTER_CART_SELECTOR = '#monster-upsell-cart';
    const MONSTER_BODY_CLASS = '_body_y9qkp_452';
    const MONSTER_INFO_CLASS = '_infos_y9qkp_392';
    const MONSTER_ROW_CLASS = '_row_y9qkp_473';
    const MONSTER_QTY_CLASS = '_qte_y9qkp_44';
    const MONSTER_CONTROL_CLASS = '_minus_y9qkp_53';
    const MONSTER_CURRENT_CLASS = '_current_y9qkp_185';
    const MONSTER_OLD_PRICE_CLASS = '_oldPrice_y9qkp_260';
    const MONSTER_LABEL_CLASS = '_label_y9qkp_50';
    const MONSTER_TITLE_CLASS = '_title_y9qkp_266';

    function isMonsterCartEnabled() {
      return Boolean(window.mu_version || window.mu_settings || window.mu_campaigns);
    }

    async function fetchCartState() {
      const response = await fetch(getCartJsonUrl(), {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch updated cart state');
      }

      return response.json();
    }

    function syncMonsterCartState(cartState) {
      if (!isMonsterCartEnabled() || !cartState) return;

      window.mu_cart_items = Array.isArray(cartState.items) ? cartState.items : [];
      window.mu_cart_count = Number(cartState.item_count || 0);
      window.mu_cart_total_price = Number(cartState.total_price || 0);
      window.mu_cart_total_discount = Number(cartState.total_discount || 0);
      window.mu_cart_currency = cartState.currency || window.Shopify?.currency?.active || window.mu_cart_currency;
      window.mu_cart = cartState;
    }

    function syncMonsterCartApp(cartState) {
      if (!isMonsterCartEnabled() || !cartState) return;

      if (typeof window.monster_setCartItems === 'function') {
        window.monster_setCartItems(
          Array.isArray(cartState.items) ? cartState.items : [],
          Array.isArray(cartState.cart_level_discount_applications) ? cartState.cart_level_discount_applications : [],
          false
        );
      }
    }

    function syncMonsterCartWithRetry(cartState, attempts = 5) {
      if (!isMonsterCartEnabled() || !cartState || attempts <= 0) return;

      syncMonsterCartApp(cartState);

      if (typeof window.monster_setCartItems === 'function') {
        return;
      }

      window.setTimeout(function () {
        syncMonsterCartWithRetry(cartState, attempts - 1);
      }, 250);
    }

    function dispatchCartEvent(target, eventName, detail) {
      if (!target || typeof target.dispatchEvent !== 'function') return;
      target.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
    }

    function broadcastCartSync(cartState, responseData) {
      const detail = {
        cart: cartState,
        cartData: cartState,
        response: responseData,
        source: 'yaynuts-bundle'
      };

      if (typeof publish === 'function') {
        publish('cart-update', detail);
      }

      dispatchCartEvent(document, 'cart:updated', detail);
      dispatchCartEvent(document.documentElement, 'cart:updated', detail);
      dispatchCartEvent(window, 'cart:updated', detail);
      dispatchCartEvent(document, 'cart-update', detail);
      dispatchCartEvent(document.documentElement, 'cart-update', detail);
      dispatchCartEvent(window, 'cart-update', detail);
    }

    function openMonsterCart(cartState) {
      if (!isMonsterCartEnabled()) return;

      if (typeof window.openCart === 'function') {
        window.openCart();
        return;
      }

      const detail = {
        cart: cartState,
        cartData: cartState,
        source: 'yaynuts-bundle'
      };

      dispatchCartEvent(document, 'cart:build', detail);
      dispatchCartEvent(document.documentElement, 'cart:build', detail);
      dispatchCartEvent(window, 'cart:build', detail);
      dispatchCartEvent(document, 'cart:open', detail);
      dispatchCartEvent(document.documentElement, 'cart:open', detail);
      dispatchCartEvent(window, 'cart:open', detail);
      dispatchCartEvent(document, 'theme:drawer:open', detail);
      dispatchCartEvent(document.documentElement, 'theme:drawer:open', detail);
      dispatchCartEvent(window, 'theme:drawer:open', detail);
    }

    function openMonsterCartWithRetry(cartState, attempts = 5) {
      if (!isMonsterCartEnabled() || attempts <= 0) return;

      openMonsterCart(cartState);

      if (typeof window.openCart === 'function') {
        return;
      }

      window.setTimeout(function () {
        openMonsterCartWithRetry(cartState, attempts - 1);
      }, 250);
    }

    function sumQuantities(quantities) {
      return Object.values(quantities || {}).reduce((sum, quantity) => sum + Number(quantity || 0), 0);
    }

    function totalSelected() {
      return sumQuantities(state.quantities);
    }

    function findSellingPlan(product, sellingPlanId) {
      return (product.sellingPlans || []).find((sp) => Number(sp.id) === Number(sellingPlanId)) || null;
    }

    function getUnitPriceCents(product, purchaseType) {
      if (purchaseType === 'subscribe') {
        const plan = findSellingPlan(product, state.sellingPlanId);
        if (plan) return Number(plan.price);
      }
      return Number(product.price);
    }

    function getRawSubtotal(quantities, purchaseType) {
      const normalizedQuantities = quantities || state.quantities;
      let subtotal = 0;

      products.forEach((product) => {
        const quantity = Number(normalizedQuantities[product.blockId] || 0);
        if (!quantity) return;
        subtotal += getUnitPriceCents(product, purchaseType) * quantity;
      });

      return subtotal;
    }

    function getTierForQuantity(totalQuantity) {
      const tiers = Array.isArray(data.tiers) ? data.tiers : [];
      if (!tiers.length) return { threshold: 0, discount: 0 };

      let active = tiers[0];
      tiers.forEach((tier) => {
        if (totalQuantity >= Number(tier.threshold || 0)) active = tier;
      });
      return active;
    }

    function getActiveTierIndex(totalQuantity) {
      const tiers = Array.isArray(data.tiers) ? data.tiers : [];
      let index = -1;
      tiers.forEach((tier, i) => {
        if (totalQuantity >= Number(tier.threshold || 0)) index = i;
      });
      return index;
    }

    function getBundleTotalPrice(quantities, purchaseType) {
      const subtotal = getRawSubtotal(quantities, purchaseType);
      const tier = getTierForQuantity(sumQuantities(quantities));
      const discount = Number(tier.discount || 0);
      return Math.round(subtotal * (1 - discount / 100));
    }

    function activePrice() {
      const total = totalSelected();
      if (total === 0) return 0;
      return (getBundleTotalPrice(state.quantities, state.purchaseType) / total) / 100;
    }

    function regularPrice() {
      const total = totalSelected();
      if (total === 0) return 0;
      return (getBundleTotalPrice(state.quantities, 'onetime') / total) / 100;
    }

    function getItemPurchaseType(item) {
      const hasSellingPlan = Boolean(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan);
      return hasSellingPlan ? 'subscribe' : 'onetime';
    }

    function isMatchingPurchaseType(item, purchaseType) {
      const normalizedPurchaseType = purchaseType || state.purchaseType;
      return getItemPurchaseType(item) === normalizedPurchaseType;
    }

    function findProductByVariantId(variantId) {
      const normalizedVariantId = Number(variantId);

      return products.find((product) => Number(product.variantId) === normalizedVariantId) || null;
    }

    function getBundleCartSnapshot(cartState, purchaseType) {
      const quantities = {};
      const keys = [];

      (cartState?.items || []).forEach((item) => {
        if (!isMatchingPurchaseType(item, purchaseType)) return;

        const product = findProductByVariantId(item.variant_id || item.id);
        if (!product) return;

        quantities[product.blockId] = (quantities[product.blockId] || 0) + Number(item.quantity || 0);
        keys.push(item.key);
      });

      return {
        quantities: quantities,
        keys: keys
      };
    }

    function getBundleCartGroups(cartState, purchaseType) {
      const groups = [];
      const groupMap = new Map();

      (cartState?.items || []).forEach((item, index) => {
        if (purchaseType && !isMatchingPurchaseType(item, purchaseType)) return;

        const product = findProductByVariantId(item.variant_id || item.id);
        if (!product) return;

        const itemPurchaseType = getItemPurchaseType(item);
        const groupKey = `${product.blockId}::${itemPurchaseType}`;
        let group = groupMap.get(groupKey);

        if (!group) {
          group = {
            key: groupKey,
            blockId: product.blockId,
            product: product,
            purchaseType: itemPurchaseType,
            quantity: 0,
            currentPrice: 0,
            originalPrice: 0,
            itemIndexes: []
          };

          groupMap.set(groupKey, group);
          groups.push(group);
        }

        group.quantity += Number(item.quantity || 0);
        group.currentPrice += Number(item.final_line_price ?? item.line_price ?? 0);
        group.originalPrice += Number(item.original_line_price ?? item.final_line_price ?? item.line_price ?? 0);
        group.itemIndexes.push(index);
      });

      return groups;
    }

    function buildBundleItems(quantities, purchaseType) {
      const items = [];

      products.forEach((product) => {
        const quantity = Number(quantities[product.blockId] || 0);
        if (!quantity || !product.variantId) return;

        const item = {
          id: Number(product.variantId),
          quantity: quantity
        };

        if (purchaseType === 'subscribe') {
          const plan = findSellingPlan(product, state.sellingPlanId);
          if (plan) {
            item.selling_plan = Number(plan.id);
          }
        }

        items.push(item);
      });

      return items;
    }

    async function clearExistingBundleItems(keys) {
      if (!keys.length) return;

      const uniqueKeys = Array.from(new Set(keys.filter(Boolean)));

      for (const key of uniqueKeys) {
        const response = await fetch(getCartChangeUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Failed to clear existing bundle items');
        }
      }
    }

    function getCartContainer() {
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      const cartNotification = isMonsterCartEnabled() ? null : document.querySelector('cart-notification');

      return {
        cartDrawer: cartDrawer,
        cartNotification: cartNotification,
        cart: cartDrawer || cartNotification
      };
    }

    function renderThemeCart(cart, cartDrawer, cartNotification, responseData) {
      if (!cart || isMonsterCartEnabled()) return;

      if (cartDrawer && window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
        return;
      }

      if (cartNotification && responseData.key) {
        cartNotification.cartItemKey = responseData.key;
      }

      if (typeof cart.renderContents === 'function') {
        cart.renderContents(responseData);
        return;
      }

      if (typeof cart.open === 'function') {
        cart.open();
      }
    }

    function getMonsterCartBody() {
      return document.querySelector(`${MONSTER_CART_SELECTOR} .${MONSTER_BODY_CLASS}`) || document.querySelector(MONSTER_CART_SELECTOR);
    }

    function hasMonsterClass(node, className) {
      return Boolean(node && node.classList && node.classList.contains(className));
    }

    function getMonsterCartBlocks() {
      const body = getMonsterCartBody();
      if (!body) return [];

      const infoNodes = Array.from(body.querySelectorAll(`.${MONSTER_INFO_CLASS}`)).filter(function (node) {
        return node instanceof Element && node.closest(`.${MONSTER_BODY_CLASS}`) === body;
      });

      if (infoNodes.length > 0) {
        return infoNodes.map(function (infoNode) {
          const rowNodes = [];
          let sibling = infoNode.nextElementSibling;

          while (sibling && !hasMonsterClass(sibling, MONSTER_INFO_CLASS)) {
            if (hasMonsterClass(sibling, MONSTER_ROW_CLASS)) {
              rowNodes.push(sibling);
            }
            sibling = sibling.nextElementSibling;
          }

          return {
            infoNode: infoNode,
            rowNodes: rowNodes
          };
        });
      }

      const blocks = [];
      let currentBlock = null;

      const nodes = Array.from(body.querySelectorAll(`.${MONSTER_INFO_CLASS}, .${MONSTER_ROW_CLASS}`));

      nodes.forEach((child) => {
        if (!(child instanceof Element)) return;

        if (hasMonsterClass(child, MONSTER_INFO_CLASS)) {
          currentBlock = {
            infoNode: child,
            rowNodes: []
          };

          blocks.push(currentBlock);
          return;
        }

        if (hasMonsterClass(child, MONSTER_ROW_CLASS) && currentBlock) {
          currentBlock.rowNodes.push(child);
        }
      });

      return blocks;
    }

    function resetMonsterCartBlock(block) {
      if (!block) return;

      block.infoNode.style.display = '';
      block.infoNode.removeAttribute('data-yaynuts-group-key');
      block.infoNode.removeAttribute('data-yaynuts-group-product');
      block.infoNode.removeAttribute('data-yaynuts-group-purchase-type');

      block.rowNodes.forEach((row) => {
        row.style.display = '';
        row.style.pointerEvents = '';
        row.removeAttribute('data-yaynuts-group-key');
        row.removeAttribute('data-yaynuts-group-product');
        row.removeAttribute('data-yaynuts-group-purchase-type');

        const input = row.querySelector('input[type="number"]');
        if (input) {
          input.readOnly = false;
        }
      });
    }

    function normalizeMonsterText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function getMonsterBlockTitle(block) {
      if (!block || !block.infoNode) return '';

      const titleNode = block.infoNode.querySelector(`.${MONSTER_TITLE_CLASS}`);
      return normalizeMonsterText(titleNode ? titleNode.textContent : block.infoNode.textContent);
    }

    function getMonsterBlocksByTitle() {
      const blocks = getMonsterCartBlocks();
      const groupedBlocks = new Map();

      blocks.forEach(function (block, index) {
        const title = getMonsterBlockTitle(block);
        if (!title) return;

        if (!groupedBlocks.has(title)) {
          groupedBlocks.set(title, []);
        }

        groupedBlocks.get(title).push({
          index: index,
          block: block
        });
      });

      return groupedBlocks;
    }

    function setMonsterCartBlockHidden(block) {
      if (!block) return;

      block.infoNode.style.display = 'none';
      block.rowNodes.forEach((row) => {
        row.style.display = 'none';
      });
    }

    function patchMonsterCartGroupBlock(block, group) {
      if (!block) return;

      block.infoNode.setAttribute('data-yaynuts-group-key', group.key);
      block.infoNode.setAttribute('data-yaynuts-group-product', group.blockId);
      block.infoNode.setAttribute('data-yaynuts-group-purchase-type', group.purchaseType);

      const currentPriceNode = block.infoNode.querySelector(`.${MONSTER_CURRENT_CLASS}`);
      if (currentPriceNode) {
        currentPriceNode.innerHTML = formatMoney(group.currentPrice, data.moneyFormat);
      }

      const oldPriceNode = block.infoNode.querySelector(`.${MONSTER_OLD_PRICE_CLASS}`);
      if (oldPriceNode) {
        if (group.originalPrice > group.currentPrice) {
          oldPriceNode.innerHTML = formatMoney(group.originalPrice, data.moneyFormat);
          oldPriceNode.style.display = '';
        } else {
          oldPriceNode.style.display = 'none';
        }
      }

      let quantityRow = null;
      let variantRow = null;

      block.rowNodes.forEach((row) => {
        row.setAttribute('data-yaynuts-group-key', group.key);
        row.setAttribute('data-yaynuts-group-product', group.blockId);
        row.setAttribute('data-yaynuts-group-purchase-type', group.purchaseType);

        if (!quantityRow && row.querySelector('input[type="number"]')) {
          quantityRow = row;
        }

        if (!variantRow && row.querySelector(`.${MONSTER_CURRENT_CLASS}`)) {
          variantRow = row;
        }
      });

      if (quantityRow) {
        const input = quantityRow.querySelector('input[type="number"]');
        if (input) {
          input.value = String(group.quantity);
          input.setAttribute('value', String(group.quantity));
          input.readOnly = true;
        }
      }

      if (variantRow) {
        const labelNode = variantRow.querySelector(`.${MONSTER_LABEL_CLASS}`);
        if (labelNode) {
          labelNode.textContent = 'Bundle Size';
        }

        const currentNode = variantRow.querySelector(`.${MONSTER_CURRENT_CLASS}`);
        if (currentNode) {
          currentNode.textContent = `${group.quantity} ${group.quantity === 1 ? 'Bag' : 'Bags'}`;
        }

        variantRow.style.pointerEvents = 'none';
      }
    }

    function applyMonsterCartGrouping() {
      monsterCartPatchQueued = false;

      if (!isMonsterCartEnabled()) return;

      const cartState = window.mu_cart;
      if (!cartState || !Array.isArray(cartState.items) || cartState.items.length === 0) return;

      const blocks = getMonsterCartBlocks();
      if (!blocks.length) return;

      blocks.forEach(resetMonsterCartBlock);

      const groups = getBundleCartGroups(cartState);
      if (!groups.length) return;
      const groupsByTitle = new Map();
      const blocksByTitle = getMonsterBlocksByTitle();

      groups.forEach(function (group) {
        const title = normalizeMonsterText(group.product?.title);
        if (!title) return;

        const existing = groupsByTitle.get(title);
        if (!existing) {
          groupsByTitle.set(title, Object.assign({}, group));
          return;
        }

        existing.quantity += group.quantity;
        existing.currentPrice += group.currentPrice;
        existing.originalPrice += group.originalPrice;
        existing.itemIndexes = existing.itemIndexes.concat(group.itemIndexes);
      });

      groupsByTitle.forEach(function (group, title) {
        const matchingBlocks = blocksByTitle.get(title) || [];
        if (!matchingBlocks.length) return;

        patchMonsterCartGroupBlock(matchingBlocks[0].block, group);

        matchingBlocks.slice(1).forEach(function (entry) {
          setMonsterCartBlockHidden(entry.block);
        });
      });
    }

    function queueMonsterCartGrouping() {
      if (!isMonsterCartEnabled() || monsterCartPatchQueued) return;

      monsterCartPatchQueued = true;
      window.requestAnimationFrame(applyMonsterCartGrouping);
    }

    function scheduleMonsterCartGrouping() {
      if (!isMonsterCartEnabled()) return;

      monsterCartGroupingTimeouts.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });
      monsterCartGroupingTimeouts = [];

      queueMonsterCartGrouping();

      [80, 180, 320, 500, 800, 1200].forEach(function (delay) {
        const timeoutId = window.setTimeout(queueMonsterCartGrouping, delay);
        monsterCartGroupingTimeouts.push(timeoutId);
      });
    }

    function bindMonsterCartGroupingEvents() {
      if (!isMonsterCartEnabled()) return;

      ['cart:updated', 'cart-update', 'cart:open', 'theme:drawer:open'].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleMonsterCartGrouping);
        window.addEventListener(eventName, scheduleMonsterCartGrouping);
      });
    }

    function observeMonsterCart() {
      if (!isMonsterCartEnabled() || monsterCartObserver) return;

      monsterCartObserver = new MutationObserver(function () {
        queueMonsterCartGrouping();
      });

      monsterCartObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      scheduleMonsterCartGrouping();
    }

    function updateHeaderCartCount(itemCount) {
      if (window.cart && typeof window.cart.updateItemsQuantity === 'function') {
        window.cart.updateItemsQuantity(itemCount);
        return;
      }

      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = itemCount;
        el.classList.toggle('hidden', itemCount === 0);
      });
    }

    async function rebuildBundleCart(quantities, purchaseType, prefetchedCartState) {
      const normalizedPurchaseType = purchaseType || state.purchaseType;
      const { cartDrawer, cartNotification, cart } = getCartContainer();
      const currentCartState = prefetchedCartState || await fetchCartState();
      const existingBundle = getBundleCartSnapshot(currentCartState, normalizedPurchaseType);
      const items = buildBundleItems(quantities, normalizedPurchaseType);

      if (existingBundle.keys.length > 0) {
        await clearExistingBundleItems(existingBundle.keys);
      }

      let responseData = {
        items: [],
        sections: {}
      };

      if (items.length > 0) {
        const formData = new FormData();

        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
          if (item.selling_plan) {
            formData.append(`items[${index}][selling_plan]`, item.selling_plan);
          }
        });

        if (cart && !cartDrawer) {
          formData.append('sections', ['cart-notification-product', 'cart-notification-button'].join(','));
          formData.append('sections_url', window.location.pathname);
        }

        if (cart && typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }

        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to update bundle cart');
        }

        responseData = await response.json();

        if (responseData.items && responseData.items.length > 0) {
          responseData.key = responseData.items[0].key;
        }
      }

      const cartState = await fetchCartState();

      updateHeaderCartCount(cartState.item_count);
      syncMonsterCartState(cartState);
      syncMonsterCartWithRetry(cartState);
      renderThemeCart(cart, cartDrawer, cartNotification, responseData);
      broadcastCartSync(cartState, responseData);
      openMonsterCartWithRetry(cartState);
      scheduleMonsterCartGrouping();

      return {
        cartState: cartState,
        responseData: responseData
      };
    }

    function parseGroupKey(groupKey) {
      const keyParts = String(groupKey || '').split('::');
      return {
        blockId: keyParts[0] || '',
        purchaseType: keyParts[1] || 'onetime'
      };
    }

    async function updateGroupedBundleQuantity(groupKey, delta) {
      const parsed = parseGroupKey(groupKey);
      if (!parsed.blockId || !delta) return;

      const currentCartState = await fetchCartState();
      const snapshot = getBundleCartSnapshot(currentCartState, parsed.purchaseType);
      const nextQuantities = Object.assign({}, snapshot.quantities);
      const currentQuantity = Number(nextQuantities[parsed.blockId] || 0);
      const nextQuantity = Math.max(0, currentQuantity + delta);

      if (nextQuantity === currentQuantity) return;

      if (nextQuantity === 0) {
        delete nextQuantities[parsed.blockId];
      } else {
        nextQuantities[parsed.blockId] = nextQuantity;
      }

      if (delta > 0 && sumQuantities(nextQuantities) > Number(data.config.maxBags || 4)) {
        return;
      }

      await rebuildBundleCart(nextQuantities, parsed.purchaseType);
    }

    function bindMonsterCartControls() {
      if (!isMonsterCartEnabled() || monsterCartControlsBound) return;

      document.addEventListener('click', function (event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const groupedRow = target.closest(`.${MONSTER_ROW_CLASS}[data-yaynuts-group-key]`);
        const groupedInfo = target.closest(`.${MONSTER_INFO_CLASS}[data-yaynuts-group-key]`);

        if (groupedRow) {
          const control = target.closest(`.${MONSTER_CONTROL_CLASS}`);
          if (!control) return;

          const delta = control.textContent && control.textContent.trim() === '+' ? 1 : -1;
          const groupKey = groupedRow.getAttribute('data-yaynuts-group-key');
          if (!groupKey) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          updateGroupedBundleQuantity(groupKey, delta).catch(function () {});
          return;
        }

        if (groupedInfo && target.closest('svg, path, use, button')) {
          const groupKey = groupedInfo.getAttribute('data-yaynuts-group-key');
          if (!groupKey) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          updateGroupedBundleQuantity(groupKey, -999).catch(function () {});
        }
      }, true);

      monsterCartControlsBound = true;
    }

    function updateHeader() {
      const current = products[state.currentIndex] || products[0];
      els.title.forEach((node) => {
        node.textContent = current.title;
      });
    }

    function renderGallery() {
      const current = products[state.currentIndex] || products[0];

      if (els.mainImage) {
        els.mainImage.src = current.galleryImage || current.featuredImage;
        els.mainImage.alt = current.title;
      }

      updateHeader();
    }

    function showPreviousImage() {
      state.currentIndex = (state.currentIndex - 1 + products.length) % products.length;
      renderGallery();
    }

    function showNextImage() {
      state.currentIndex = (state.currentIndex + 1) % products.length;
      renderGallery();
    }

    function renderSubscribeFrequency() {
      if (!els.subscribeFrequency) return;
      const plans = products[0]?.sellingPlans || [];
      els.subscribeFrequency.innerHTML = '';

      if (!plans.length) {
        els.subscribeFrequency.disabled = true;
        return;
      }

      plans.forEach((plan) => {
        const option = createEl('option', '', plan.name);
        option.value = plan.id;
        if (Number(plan.id) === Number(state.sellingPlanId)) option.selected = true;
        els.subscribeFrequency.appendChild(option);
      });

      els.subscribeFrequency.addEventListener('change', function () {
        state.sellingPlanId = Number(els.subscribeFrequency.value);
        refresh();
      });
    }

    function renderNutritionList() {
      if (els.nutritionLists.length === 0) return;
      
      els.nutritionLists.forEach(list => {
        list.innerHTML = '';
        products.forEach((product) => {
          const item = createEl('button', 'flavor-item flex w-full items-center gap-3 p-3 hover:bg-gray-100 cursor-pointer');
          item.type = 'button';
          item.innerHTML = `<img src="${product.featuredImage}" class="w-10 h-10 rounded" alt="${product.title}"><span>${product.title}</span>`;
          item.addEventListener('click', function () {
            els.selectedFlavors.forEach(sf => {
              sf.textContent = `${data.texts.flavorPrefix} ${product.title}`;
            });
            els.nutritionImages.forEach(ni => {
              ni.src = product.nutritionImage || product.featuredImage;
              ni.alt = product.title;
              ni.classList.remove('hidden');
            });
            els.nutritionLists.forEach(nl => nl.classList.add('hidden'));
          });
          list.appendChild(item);
        });
      });
    }

    function renderFlavors() {
      if (!els.flavorList) return;
      els.flavorList.innerHTML = '';
      const total = totalSelected();

      products.forEach((product) => {
        const qty = state.quantities[product.blockId] || 0;
        const card = createEl('div', 'flavor-card bg-white  border border-gray-200 p-0 overflow-hidden flex items-center gap-2 md:gap-4');
        const controls = qty === 0
          ? `<button type="button" class="bg-primary text-white px-2 py-0 md:px-6 md:py-0 w-[73px] h-[23px] sm:w-[73px] sm:h-[23px] md:w-[100px] md:h-[32px] lg:w-[100px] lg:h-[32px] xl:w-[100px] xl:h-[32px] rounded-full font-semibold text-[10px] sm:text-[11px] md:text-sm hover:bg-primary/90 transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed" data-add-flavor ${total >= data.config.maxBags ? 'disabled' : ''}>Add +</button>`
          : `<div class="flex items-center jusfiy-center bg-primary rounded-full gap-[9px] sm:gap-[9px] p-1 w-[73px] h-[23px] sm:w-[73px] sm:h-[23px] md:w-[100px] md:h-[32px] lg:w-[100px] lg:h-[32px] xl:w-[100px] xl:h-[32px]"><button type="button" data-change-qty="-1" class="quantity-btn w-3 h-3 md:w-5 md:h-5 rounded-full bg-white/20 text-white flex items-center justify-center hover:bg-white/30"><svg class="w-3 h-3 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path></svg></button><span class="w-5 md:w-10 text-center text-[10px] md:text-[12px] text-white font-bold">${qty}</span><button type="button" data-change-qty="1" class="quantity-btn w-3 h-3 md:w-5 md:h-5 rounded-full bg-white/20 text-white flex items-center justify-center hover:bg-white/30"><svg class="w-3 h-3 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg></button></div>`;

        card.innerHTML = `
          <div class="relative flavor-ibox" style="background-color:${product.cardColor || '#8be2e9'}">
            <img src="${product.featuredImage}" alt="${product.title}" class="h-16  object-cover">
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="font-bold text-[14px] sm:text-[14px] md:text-[14px] lg:text-[16px] xl:text-[16px] text-primary">${product.title}</h4>
            <p class="text-[8px] sm:text-[8px] md:text-[10px] lg:text-[10px] xl:text-[12px] text-primary">${product.description || ''}</p>
          </div>
          ${product.badge ? `<span class="absolute text-center badge-popular top-0 right-3 md:right-4 w-[68px] h-[13px]  md:w-[84px] md:h-[17px] leading-[5px] sm:leading-[5px] md:leading-[10px] rounded-b-[6px] text-white text-[8px] md:text-[10px] font-bold px-1 py-1 md:px-2 md:py-1">${product.badge}</span>` : ''}
          <div class="flex items-center gap-2 pr-3">
            <span class="text-[11px] md:text-[13px] font-bold text-primary whitespace-nowrap">${formatMoney(getUnitPriceCents(product, state.purchaseType), data.moneyFormat)}</span>
            ${controls}
          </div>
        `;

        const addButton = card.querySelector('[data-add-flavor]');
        if (addButton) {
          addButton.addEventListener('click', function () {
            if (totalSelected() >= data.config.maxBags) return;
            state.quantities[product.blockId] = 1;
            refresh();
          });
        }

        card.querySelectorAll('[data-change-qty]').forEach((button) => {
          button.addEventListener('click', function () {
            const change = Number(button.getAttribute('data-change-qty'));
            const current = state.quantities[product.blockId] || 0;
            const next = current + change;
            if (next < 0) return;
            if (change > 0 && totalSelected() >= data.config.maxBags) return;
            if (next === 0) {
              delete state.quantities[product.blockId];
            } else {
              state.quantities[product.blockId] = next;
            }
            refresh();
          });
        });

        els.flavorList.appendChild(card);
      });
    }

    function updateProgress() {
      const total = totalSelected();
      const progress = Math.min((total / Number(data.config.progressTarget || 1)) * 100, 100);
      if (els.progress) {
        els.progress.style.width = `${progress}%`;
        // Ensure the progress bar has proper styling
        els.progress.style.height = '100%';
        els.progress.style.backgroundColor = '#056A9B'; // Use the exact color from CSS
        els.progress.style.display = 'block';
        els.progress.style.visibility = 'visible';
        els.progress.style.opacity = '1';
        els.progress.style.minWidth = '0%';
        els.progress.style.maxWidth = '100%';
        els.progress.style.position = 'relative';
      }

      els.steps.forEach((step, index) => {
        const active = total >= index + 1;
        // Find the circle element by looking for the div with border classes
        const circle = step.querySelector('div[class*="border-primary"]') ||
                      step.querySelector('div[class*="border-gray-300"]') ||
                      step.querySelector('div.rounded-full');
        const dot = step.querySelector('.dot');
        if (circle) {
          circle.classList.toggle('border-primary', active);
          circle.classList.toggle('border-gray-300', !active);
        }
        if (dot) {
          dot.classList.toggle('bg-primary', active);
          dot.classList.toggle('bg-transparent', !active);
        }
      });
    }

    function updatePurchaseBoxes() {
      const subscribeActive = state.purchaseType === 'subscribe';
      if (els.radioSubscribe) els.radioSubscribe.checked = subscribeActive;
      if (els.radioOnetime) els.radioOnetime.checked = !subscribeActive;
      if (els.subscribeBox) {
        els.subscribeBox.classList.toggle('border-primary', subscribeActive);
        els.subscribeBox.classList.toggle('shadow-xl', subscribeActive);
      }
      if (els.onetimeBox) {
        els.onetimeBox.classList.toggle('border-primary', !subscribeActive);
        els.onetimeBox.classList.toggle('bg-white', !subscribeActive);
        els.onetimeBox.classList.toggle('border-gray-200', subscribeActive);
        els.onetimeBox.classList.toggle('bg-gray-50', subscribeActive);
      }
    }

    function updateTierHighlight() {
      const totalQuantity = totalSelected();
      const activeIndex = getActiveTierIndex(totalQuantity);
      const tiers = Array.isArray(data.tiers) ? data.tiers : [];

      els.tierCols.forEach((col, i) => {
        col.classList.toggle('is-active', i === activeIndex);
      });

      els.tierSegments.forEach((segment, i) => {
        const lower = Number(tiers[i] ? tiers[i].threshold : 0);
        const upper = Number(tiers[i + 1] ? tiers[i + 1].threshold : lower);
        const span = upper - lower;
        const progress = span > 0
          ? Math.max(0, Math.min(1, (totalQuantity - lower) / span))
          : (totalQuantity >= upper ? 1 : 0);
        const pct = (progress * 100).toFixed(2) + '%';
        segment.classList.toggle('active', progress >= 1);
        segment.style.background = `linear-gradient(to right, #6D2209 ${pct}, rgba(109,34,9,0.25) ${pct})`;
      });
    }

    function updateGiftUnlocks() {
      const totalQuantity = totalSelected();
      els.giftItems.forEach((item) => {
        const threshold = Number(item.getAttribute('data-gift-threshold') || 0);
        item.classList.toggle('is-unlocked', totalQuantity >= threshold);
      });
    }

    async function syncGiftUnlocks(totalQuantity, prefetchedCartState) {
      const eligibleGifts = els.giftItems.filter((item) => {
        return totalQuantity >= Number(item.getAttribute('data-gift-threshold') || 0);
      });
      if (eligibleGifts.length === 0) return prefetchedCartState;

      const cartState = prefetchedCartState || await fetchCartState();
      const cartVariantIds = (cartState.items || []).map((item) => Number(item.variant_id));

      const itemsToAdd = eligibleGifts
        .map((item) => Number(item.getAttribute('data-gift-variant-id')))
        .filter((variantId) => variantId && !cartVariantIds.includes(variantId));

      if (itemsToAdd.length === 0) return cartState;

      const formData = new FormData();
      itemsToAdd.forEach((variantId, index) => {
        formData.append(`items[${index}][id]`, variantId);
        formData.append(`items[${index}][quantity]`, 1);
      });

      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        console.error('[chocbox-bundle] failed to add free gifts to cart');
        return cartState;
      }

      return await fetchCartState();
    }

    function updateSubscribeDiscountBadge() {
      if (!els.subDiscountBadge) return;
      const plan = products[0] ? findSellingPlan(products[0], state.sellingPlanId) : null;
      const basePrice = Number(products[0]?.price || 0);
      if (!plan || !basePrice) {
        els.subDiscountBadge.textContent = '';
        return;
      }
      const pct = Math.round((1 - Number(plan.price) / basePrice) * 100);
      els.subDiscountBadge.textContent = pct > 0 ? `${pct}%` : '';
    }

    function updatePrices() {
      const total = totalSelected();

      const price = activePrice();
      const regular = regularPrice();
      if (els.subOriginal) els.subOriginal.textContent = `${formatMoney(regular * 100, data.moneyFormat)}/ea`;
      if (els.subPrice) els.subPrice.textContent = `${formatMoney(price * 100, data.moneyFormat)}/ea`;
      if (els.onetimePrice) els.onetimePrice.textContent = `${formatMoney(regular * 100, data.moneyFormat)}/ea`;

      const finalTotal = price * total;
      const originalTotal = regular * total;
      if (els.btnOriginal) els.btnOriginal.textContent = formatMoney(originalTotal * 100, data.moneyFormat);
      if (els.btnFinal) els.btnFinal.textContent = formatMoney(finalTotal * 100, data.moneyFormat);
      if (els.cartPricing) els.cartPricing.classList.toggle('hidden', total === 0);

      updateTierHighlight();
      updateSubscribeDiscountBadge();
    }

    function updateButton() {
      const total = totalSelected();
      if (!els.cartButton || !els.cartButtonText) return;
      els.cartButton.disabled = total === 0 || state.adding;
      if (state.adding) {
        els.cartButtonText.textContent = data.texts.buttonAdding;
        return;
      }
      els.cartButtonText.textContent = total > 0
        ? `${data.texts.buttonLabel} (${total})`
        : data.texts.buttonEmpty;
      els.cartButton.classList.toggle('bg-primary', total > 0);
      els.cartButton.classList.toggle('text-white', total > 0);
      els.cartButton.classList.toggle('btn-default', total === 0);
    }

    function updateStatus() {
      if (!els.selectionStatus) return;
      const total = totalSelected();
      const remaining = Number(data.config.progressTarget) - total;
      if (remaining <= 0) {
        els.selectionStatus.textContent = data.texts.selectionComplete;
      } else {
        els.selectionStatus.textContent = `${data.texts.selectionPrefix} ${remaining} more bag${remaining === 1 ? '' : 's'}`;
      }
    }

    function refresh() {
      renderFlavors();
      updateProgress();
      updatePurchaseBoxes();
      updatePrices();
      updateButton();
      updateStatus();
      updateGiftUnlocks();
    }

    async function addToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const total = totalSelected();
      if (state.adding || total === 0) return;
      state.adding = true;
      updateButton();

      let cartState;
      let responseData;

      if (total === 0) {
        state.adding = false;
        updateButton();
        els.cartButtonText.textContent = 'Unable to add bundle';
        return;
      }

      try {
        const currentCartState = await fetchCartState();
        const existingBundle = getBundleCartSnapshot(currentCartState);
        const mergedQuantities = Object.assign({}, existingBundle.quantities);

        Object.keys(state.quantities).forEach((blockId) => {
          mergedQuantities[blockId] = Number(mergedQuantities[blockId] || 0) + Number(state.quantities[blockId] || 0);
        });

        if (sumQuantities(mergedQuantities) === 0) {
          throw new Error('No bundle items available to add');
        }
        const rebuildResult = await rebuildBundleCart(mergedQuantities, state.purchaseType, currentCartState);
        cartState = rebuildResult.cartState;
        responseData = rebuildResult.responseData;

        const cartStateWithGifts = await syncGiftUnlocks(sumQuantities(mergedQuantities), cartState);
        if (cartStateWithGifts && cartStateWithGifts !== cartState) {
          cartState = cartStateWithGifts;
          const { cartDrawer, cartNotification, cart } = getCartContainer();
          updateHeaderCartCount(cartState.item_count);
          renderThemeCart(cart, cartDrawer, cartNotification, responseData);
        }

        state.quantities = {};
        refresh();
        if (els.cartButtonText) {
          els.cartButtonText.textContent = data.texts.buttonAdded;
        }

      } catch (error) {
        console.error('[chocbox-bundle] addToCart failed', error);
        els.cartButtonText.textContent = 'Unable to add bundle';
      } finally {
        state.adding = false;
        setTimeout(updateButton, 1500);
      }
    }

    if (els.subscribeBox) {
      els.subscribeBox.addEventListener('click', function () {
        state.purchaseType = 'subscribe';
        refresh();
      });
    }

    if (els.onetimeBox) {
      els.onetimeBox.addEventListener('click', function () {
        state.purchaseType = 'onetime';
        refresh();
      });
    }

    if (els.nutritionToggles.length > 0) {
      els.nutritionToggles.forEach(toggle => {
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          state.nutritionOpen = !state.nutritionOpen;

          if (state.nutritionOpen) {
            els.nutritionLists.forEach(nl => nl.classList.remove('hidden'));
            els.nutritionImages.forEach(ni => ni.classList.add('hidden'));
            els.selectedFlavors.forEach(sf => {
              sf.textContent = `${data.texts.flavorPrefix}`;
            });
          }

          els.nutritionDropdowns.forEach(nd => nd.classList.toggle('hidden', !state.nutritionOpen));
          els.nutritionIcons.forEach(ni => ni.classList.toggle('rotate-180', state.nutritionOpen));
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-nutrition-toggle]') || event.target.closest('[data-nutrition-dropdown]')) return;
        state.nutritionOpen = false;
        els.nutritionDropdowns.forEach(nd => nd.classList.add('hidden'));
        els.nutritionIcons.forEach(ni => ni.classList.remove('rotate-180'));
      });
    }

    if (els.cartButton) {
      els.cartButton.addEventListener('click', addToCart);
    }

    if (els.prevArrow) {
      els.prevArrow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showPreviousImage();
      });
    }

    if (els.nextArrow) {
      els.nextArrow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showNextImage();
      });
    }

    const mainContainer = section.querySelector('.main-image-container');
    if (mainContainer) {
      let startX = 0;
      let startY = 0;
      mainContainer.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].screenX;
        startY = event.changedTouches[0].screenY;
      }, { passive: true });
      mainContainer.addEventListener('touchend', function (event) {
        const diffX = event.changedTouches[0].screenX - startX;
        const diffY = event.changedTouches[0].screenY - startY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) {
            showPreviousImage();
          } else {
            showNextImage();
          }
        }
      }, { passive: true });
    }

    renderGallery();
    renderNutritionList();
    renderSubscribeFrequency();
    refresh();
    observeMonsterCart();
    bindMonsterCartGroupingEvents();
    bindMonsterCartControls();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-config]').forEach((configNode) => {
      const section = configNode.closest('[data-section-id]');
      if (section) {
        initBundleSection(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
